import Menu from 'antd/es/menu';
import Dropdown from 'antd/es/dropdown';
import { useTranslation } from 'react-i18next';
import i18n from '@locales/i18n'; // Ensure you have initialized i18n
import { LANGUAGES } from '@locales/languages';

const LanguageSelector = () => {
  const { t } = useTranslation();

  const handleMenuClick = (e: any) => {
    i18n.changeLanguage(e.key);
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="vi">{t('common.vietnamese')}</Menu.Item>
      <Menu.Item key="en">{t('common.english')}</Menu.Item>
    </Menu>
  );

  return (
    <div className="hidden">
      <Dropdown overlay={menu}>
        <img alt="language"
          width={32}
            src={
              LANGUAGES.find((lang) =>
                new RegExp(lang.code, 'gi').test(i18n.language)
              )?.flag || LANGUAGES[0].flag
            } />
      </Dropdown>
    </div>
  );
};

export default LanguageSelector;

